
import Vue from "vue";
import AppPriceListBrowse from "@/components/price-lists/PriceListBrowse.vue";


export default Vue.extend({
	components: {
		AppPriceListBrowse
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
